module.exports = __webpack_public_path__ + "fonts/futura-t-bold.50d53542.ttf";